import { render, staticRenderFns } from "./TemplateCommunities.vue?vue&type=template&id=809f9686&scoped=true"
import script from "./TemplateCommunities.vue?vue&type=script&lang=js"
export * from "./TemplateCommunities.vue?vue&type=script&lang=js"
import style0 from "./TemplateCommunities.vue?vue&type=style&index=0&id=809f9686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "809f9686",
  null
  
)

export default component.exports